exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#loading{position:absolute;top:49%;right:0;left:0;text-align:center}\n", ""]);

